import React, { useState, useEffect } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { get, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import { checkPermission } from "../redux/api/PermissionManager";

function OfficeIp() {
  const [isIpAddress, setIsIpAddress] = useState({
    ipaddress_first: { id: "", value: "" },
    ipaddress_sec: { id: "", value: "" },
  });
  const [isEdit, setIsEdit] = useState({
    first: false,
    sec: false,
  });
  useEffect(() => {
    fetchVersion();
  }, []);

  const fetchVersion = async () => {
    const res = await get(URLS.VOW_VERSION_LIST);
    if (res?.status === "success") {
      const updatedVersion = {
        ipaddress_first: { id: "", value: "" },
        ipaddress_sec: { id: "", value: "" },
      };

      const type8Items = res.data.filter((item) => item.type === 8);

      if (type8Items[0]) {
        updatedVersion.ipaddress_first = {
          id: type8Items[0].id,
          value: type8Items[0].setting_value,
        };
      }
      if (type8Items[1]) {
        updatedVersion.ipaddress_sec = {
          id: type8Items[1].id,
          value: type8Items[1].setting_value,
        };
      }

      setIsIpAddress(updatedVersion);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setIsIpAddress((prev) => ({
      ...prev,
      [name]: { ...prev[name], value },
    }));
  };

  const handlerUpdateSupport = async () => {
    if (
      !isIpAddress.ipaddress_first.value &&
      !isIpAddress.ipaddress_sec.value
    ) {
      alert("Please enter at least one IP address.");
      return;
    }

    const updates = [];

    if (isEdit.first) {
      updates.push({
        id: isIpAddress.ipaddress_first.id,
        value: isIpAddress.ipaddress_first.value,
      });
    }

    if (isEdit.sec) {
      updates.push({
        id: isIpAddress.ipaddress_sec.id,
        value: isIpAddress.ipaddress_sec.value,
      });
    }

    for (const item of updates) {
      const payload = new FormData();
      payload.append("type", 8);
      payload.append("setting_value", item.value);

      const url = URLS.VOW_VERSION_UPDATE + `${item.id}` + "/update/";
      const res = await put(url, payload);

      if (res?.status === "success") {
        toast.success(res?.message);
      }
    }

    fetchVersion();
    setIsEdit({ first: false, sec: false });
  };

  const anyEditing = isEdit.first || isEdit.sec;

  return (
    <div>
      <Topbar header={"Settings"} subHead={"Office IP"} />
      <div className="row">
        <div className="col-md-6">
          <div
            style={{
              flexDirection: "row",
              alignItems: "flex-end",
              display: "flex",
              gap: 10,
            }}
          >
            <div>
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Office IP Address - 01
              </label>
              <input
                className="input-box"
                name="ipaddress_first"
                value={isIpAddress.ipaddress_first.value}
                onChange={handleChange}
                placeholder="Enter IP Address"
                disabled={!isEdit.first}
              />
            </div>
            {checkPermission("CAN-EDIT-OFFICE_IP") && (
              <>
                {!isEdit.first && (
                  <button
                    onClick={() =>
                      setIsEdit((prev) => ({ ...prev, first: true }))
                    }
                    className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn"
                  >
                    Edit
                  </button>
                )}
              </>
            )}
          </div>

          <div
            style={{
              flexDirection: "row",
              alignItems: "flex-end",
              display: "flex",
              gap: 10,
              marginTop: 30,
            }}
          >
            <div>
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Office IP Address - 02
              </label>
              <input
                className="input-box"
                name="ipaddress_sec"
                value={isIpAddress.ipaddress_sec.value}
                onChange={handleChange}
                placeholder="Enter IP Address"
                disabled={!isEdit.sec}
              />
            </div>
            {checkPermission("CAN-EDIT-OFFICE_IP") && (
              <>
                {!isEdit.sec && (
                  <button
                    onClick={() =>
                      setIsEdit((prev) => ({ ...prev, sec: true }))
                    }
                    className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn"
                  >
                    Edit
                  </button>
                )}
              </>
            )}
          </div>

          {anyEditing && (
            <button
              onClick={handlerUpdateSupport}
              className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn mt-3"
            >
              Update
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default OfficeIp;
